import { NgModule } from '@angular/core';

import { ImageModule } from 'Angular/features/directives/image/image.module';

import { PasswordRevealComponent } from './password-reveal.component';

@NgModule({
    declarations: [PasswordRevealComponent],
    exports: [PasswordRevealComponent],
    imports: [ImageModule],
})
export class PasswordRevealModule {}
